<nav id="side-navigation" class="py-3">
  <div id="logo-wrapper" class="mx-3 mb-3">
    <a [routerLink]="['/']" (click)="triggerHide()">
      <img class="logo" src="assets/logo.svg" alt="logo"/>
    </a>
  </div>
  <div class="p-2">
    <app-global-search-input (search)="triggerHide()"></app-global-search-input>
  </div>
  <p-panelMenu [model]="sections"></p-panelMenu>
</nav>
